import { render } from "./Register.vue?vue&type=template&id=f4ed9f3e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=f4ed9f3e&scoped=true&lang=css"

import exportComponent from "D:\\git\\Homepage\\vue3home\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ed9f3e"]])

export default __exports__